function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = function(fn, res) {
    return function __init() {
        return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
};
var __commonJS = function(cb, mod) {
    return function __require() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && (typeof from === "undefined" ? "undefined" : _type_of(from)) === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/integrations/asana.js
var asana_exports = {};
__export(asana_exports, {
    getProjectStatus: function() {
        return getProjectStatus;
    }
});
function getProjectStatus(status) {
    switch(status){
        case "achieved":
        case "complete":
            return "completed";
        case "off_track":
        case "missed":
            return "at_risk";
        case "partial":
        case "dropped":
            return "on_hold";
        default:
            return status;
    }
}
var init_asana = __esm({
    "src/integrations/asana.js": function() {}
});
// ../../node_modules/.pnpm/format@0.2.2/node_modules/format/format.js
var require_format = __commonJS({
    "../../node_modules/.pnpm/format@0.2.2/node_modules/format/format.js": function(exports, module) {
        (function() {
            var namespace;
            if (typeof module !== "undefined") {
                namespace = module.exports = format;
            } else {
                namespace = function() {
                    return this || (1, eval)("this");
                }();
            }
            namespace.format = format;
            namespace.vsprintf = vsprintf;
            if (typeof console !== "undefined" && typeof console.log === "function") {
                namespace.printf = printf;
            }
            function printf() {
                console.log(format.apply(null, arguments));
            }
            function vsprintf(fmt, replacements) {
                return format.apply(null, [
                    fmt
                ].concat(replacements));
            }
            function format(fmt) {
                var argIndex = 1, args = [].slice.call(arguments), i = 0, n = fmt.length, result = "", c2, escaped = false, arg, tmp, leadingZero = false, precision, nextArg = function nextArg() {
                    return args[argIndex++];
                }, slurpNumber = function slurpNumber() {
                    var digits = "";
                    while(/\d/.test(fmt[i])){
                        digits += fmt[i++];
                        c2 = fmt[i];
                    }
                    return digits.length > 0 ? parseInt(digits) : null;
                };
                for(; i < n; ++i){
                    c2 = fmt[i];
                    if (escaped) {
                        escaped = false;
                        if (c2 == ".") {
                            leadingZero = false;
                            c2 = fmt[++i];
                        } else if (c2 == "0" && fmt[i + 1] == ".") {
                            leadingZero = true;
                            i += 2;
                            c2 = fmt[i];
                        } else {
                            leadingZero = true;
                        }
                        precision = slurpNumber();
                        switch(c2){
                            case "b":
                                result += parseInt(nextArg(), 10).toString(2);
                                break;
                            case "c":
                                arg = nextArg();
                                if (typeof arg === "string" || _instanceof(arg, String)) result += arg;
                                else result += String.fromCharCode(parseInt(arg, 10));
                                break;
                            case "d":
                                result += parseInt(nextArg(), 10);
                                break;
                            case "f":
                                tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
                                result += leadingZero ? tmp : tmp.replace(/^0/, "");
                                break;
                            case "j":
                                result += JSON.stringify(nextArg());
                                break;
                            case "o":
                                result += "0" + parseInt(nextArg(), 10).toString(8);
                                break;
                            case "s":
                                result += nextArg();
                                break;
                            case "x":
                                result += "0x" + parseInt(nextArg(), 10).toString(16);
                                break;
                            case "X":
                                result += "0x" + parseInt(nextArg(), 10).toString(16).toUpperCase();
                                break;
                            default:
                                result += c2;
                                break;
                        }
                    } else if (c2 === "%") {
                        escaped = true;
                    } else {
                        result += c2;
                    }
                }
                return result;
            }
        })();
    }
});
// src/assistant-fallback-reasons.js
var error = "error";
var zero_results = "zero-results";
var assistant_fallback_reasons_default = {
    error: error,
    zero_results: zero_results
};
// src/capabilities.js
var capabilities_exports = {};
__export(capabilities_exports, {
    prefix: function() {
        return prefix;
    },
    separator: function() {
        return separator;
    }
});
var prefix = "capabilities";
var separator = ":";
// src/constants.js
var SOFT_DELETE_DAY_INTERVAL = 30;
var constants_default = {
    SOFT_DELETE_DAY_INTERVAL: SOFT_DELETE_DAY_INTERVAL
};
// src/exports.js
var ATTR_TYPE_TO_VALUE = {
    entity_instances: function(data) {
        return Array.isArray(data) ? data.map(function(v) {
            return v.display_name;
        }).join(",") : data;
    },
    file: function(data) {
        return data === null || data === void 0 ? void 0 : data.url;
    },
    people: function(data) {
        return data === null || data === void 0 ? void 0 : data.map(function(v) {
            return v.display_name;
        }).join(",");
    },
    team: function(data) {
        return data === null || data === void 0 ? void 0 : data.map(function(v) {
            return v.name;
        }).join(",");
    },
    url: function(data) {
        return data === null || data === void 0 ? void 0 : data.url;
    }
};
var ENTITIES_EXPORT_MAPPINGS = {
    entity_instances: {
        fields: [
            {
                label: "Unique id",
                slug: "id"
            },
            {
                label: "Name",
                slug: "display_name"
            },
            {
                label: "Tags",
                marshall: function(data) {
                    var _data_tags_map, _data_tags;
                    return data === null || data === void 0 ? void 0 : (_data_tags = data.tags) === null || _data_tags === void 0 ? void 0 : (_data_tags_map = _data_tags.map(function(t) {
                        return t.name;
                    })) === null || _data_tags_map === void 0 ? void 0 : _data_tags_map.join(",");
                },
                slug: "tags"
            },
            {
                label: "Module type",
                marshall: function(data) {
                    return data === null || data === void 0 ? void 0 : data.type;
                },
                slug: "module_type"
            },
            {
                label: "Collaborators",
                marshall: function(data) {
                    var _data_entity_permissions_filter_map, _data_entity;
                    return data === null || data === void 0 ? void 0 : (_data_entity = data.entity) === null || _data_entity === void 0 ? void 0 : (_data_entity_permissions_filter_map = _data_entity.permissions.filter(function(p) {
                        var _p_access_entity;
                        return p === null || p === void 0 ? void 0 : (_p_access_entity = p.access_entity) === null || _p_access_entity === void 0 ? void 0 : _p_access_entity.person;
                    }).map(function(p) {
                        var _p_access_entity_person, _p_access_entity;
                        return p === null || p === void 0 ? void 0 : (_p_access_entity = p.access_entity) === null || _p_access_entity === void 0 ? void 0 : (_p_access_entity_person = _p_access_entity.person) === null || _p_access_entity_person === void 0 ? void 0 : _p_access_entity_person.display_name;
                    })) === null || _data_entity_permissions_filter_map === void 0 ? void 0 : _data_entity_permissions_filter_map.join(",");
                },
                slug: "collaborators"
            },
            {
                label: "Collaborators email addresess",
                marshall: function(data) {
                    var _data_entity_permissions_filter_map, _data_entity;
                    return data === null || data === void 0 ? void 0 : (_data_entity = data.entity) === null || _data_entity === void 0 ? void 0 : (_data_entity_permissions_filter_map = _data_entity.permissions.filter(function(p) {
                        var _p_access_entity;
                        return p === null || p === void 0 ? void 0 : (_p_access_entity = p.access_entity) === null || _p_access_entity === void 0 ? void 0 : _p_access_entity.person;
                    }).map(function(p) {
                        var _p_access_entity_person, _p_access_entity;
                        return p === null || p === void 0 ? void 0 : (_p_access_entity = p.access_entity) === null || _p_access_entity === void 0 ? void 0 : (_p_access_entity_person = _p_access_entity.person) === null || _p_access_entity_person === void 0 ? void 0 : _p_access_entity_person.email_addresses;
                    })) === null || _data_entity_permissions_filter_map === void 0 ? void 0 : _data_entity_permissions_filter_map.join(",");
                },
                slug: "collaborators_email_addresses"
            },
            {
                label: "Custom fields",
                marshall: function(data) {
                    var entityType = data.entityType, values = data.values;
                    var attributes = entityType.attributes;
                    if (attributes.length === 0 || !entityType) {
                        return null;
                    }
                    var resp = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var a = _step.value;
                            var key = a.name, slug = a.slug, type = a.type;
                            var value = values[slug];
                            if (ATTR_TYPE_TO_VALUE[type]) {
                                resp[key] = ATTR_TYPE_TO_VALUE[type](value) || null;
                            } else if (Array.isArray(value)) {
                                resp[key] = value.join(",");
                            } else {
                                resp[key] = value;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return resp;
                },
                slug: "custom_fields"
            },
            {
                label: "Item created at",
                slug: "created_at"
            },
            {
                label: "Item last updated at",
                slug: "updated_at"
            },
            {
                label: "Item archived at",
                marshall: function(data) {
                    var _data_entity;
                    return data === null || data === void 0 ? void 0 : (_data_entity = data.entity) === null || _data_entity === void 0 ? void 0 : _data_entity.archived_at;
                },
                slug: "archived_at"
            },
            {
                label: "Number of tasks",
                slug: "count_tasks"
            },
            {
                label: "Number of threads",
                slug: "count_threads"
            },
            {
                label: "Number of pages",
                slug: "count_pages"
            },
            {
                label: "Number of workflows",
                slug: "count_workflows"
            },
            {
                label: "Number of teams",
                slug: "count_teams"
            },
            {
                label: "Number of relationships",
                marshall: function(data) {
                    var _data_relationships;
                    return data === null || data === void 0 ? void 0 : (_data_relationships = data.relationships) === null || _data_relationships === void 0 ? void 0 : _data_relationships.length;
                },
                slug: "count_relationships"
            },
            {
                label: "Number of measurements",
                marshall: function(data) {
                    var _data_measurements;
                    return data === null || data === void 0 ? void 0 : (_data_measurements = data.measurements) === null || _data_measurements === void 0 ? void 0 : _data_measurements.length;
                },
                slug: "count_measurements"
            },
            {
                label: "Number of resources",
                marshall: function(data) {
                    var _data_resources;
                    return data === null || data === void 0 ? void 0 : (_data_resources = data.resources) === null || _data_resources === void 0 ? void 0 : _data_resources.length;
                },
                slug: "count_resources"
            },
            {
                label: "Number of timeline phases",
                marshall: function(data) {
                    var _data_timelines;
                    return data === null || data === void 0 ? void 0 : (_data_timelines = data.timelines) === null || _data_timelines === void 0 ? void 0 : _data_timelines.length;
                },
                slug: "count_timeline_phases"
            },
            {
                label: "Number of integrations",
                marshall: function(data) {
                    var _data_person_integration_mappings, _data_person, _data_integration_mappings;
                    return (data === null || data === void 0 ? void 0 : (_data_person = data.person) === null || _data_person === void 0 ? void 0 : (_data_person_integration_mappings = _data_person.integration_mappings) === null || _data_person_integration_mappings === void 0 ? void 0 : _data_person_integration_mappings.length) || (data === null || data === void 0 ? void 0 : (_data_integration_mappings = data.integration_mappings) === null || _data_integration_mappings === void 0 ? void 0 : _data_integration_mappings.length);
                },
                slug: "count_integrations"
            },
            {
                builtin_type: "people",
                label: "Role",
                marshall: function(data) {
                    var _data_person;
                    return data === null || data === void 0 ? void 0 : (_data_person = data.person) === null || _data_person === void 0 ? void 0 : _data_person.org_role;
                },
                slug: "org_role"
            },
            {
                builtin_type: "people",
                label: "Last logged in at",
                marshall: function(data) {
                    var _data_person;
                    return data === null || data === void 0 ? void 0 : (_data_person = data.person) === null || _data_person === void 0 ? void 0 : _data_person.last_logged_in_at;
                },
                slug: "last_logged_in_at"
            }
        ],
        query: "query ExportEntities($where: JSON, $filters: Filters) {\n        entity_instances(where: $where, filters: $filters) {\n          id\n          display_name\n          values\n          tags {\n            name\n          }\n          created_at\n          updated_at\n          type\n          entity {\n            archived_at\n            permissions {\n              access_entity {\n                person {\n                  display_name\n                  email_addresses\n                }\n              }\n            }\n          }\n          relationships {\n            subject_id\n          }\n          resources {\n            id\n          }\n          measurements {\n            id\n          }\n          timelines {\n            id\n          }\n          integration_mappings {\n            id\n          }\n          count_tasks\n          count_threads\n          count_pages\n          count_workflows\n          count_teams\n          person {\n            org_role\n            last_logged_in_at\n            integration_mappings {\n              id\n            }\n          }\n        }\n      }"
    },
    pages: {
        fields: [
            {
                label: "Unique id",
                slug: "id"
            },
            {
                label: "Title",
                slug: "title"
            },
            {
                label: "Parent item unique id",
                marshall: function(data) {
                    var _data_primary_entity;
                    return data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.id;
                },
                slug: "parent_item_unique_id"
            },
            {
                label: "Parent item unique name",
                marshall: function(data) {
                    var _data_primary_entity;
                    var parentName;
                    switch(data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.type){
                        case "entity_instances":
                            parentName = data.primary_entity.entity_instance.display_name;
                            break;
                        case "people":
                            parentName = data.primary_entity.person.display_name;
                            break;
                        case "teams":
                            parentName = data.primary_entity.team.name;
                            break;
                        default:
                            break;
                    }
                    return parentName;
                },
                slug: "parent_item_unique_name"
            },
            {
                label: "Parent item type",
                marshall: function(data) {
                    var _data_primary_entity;
                    return data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.type;
                },
                slug: "parent_item_type"
            },
            {
                label: "Page author name",
                marshall: function(data) {
                    var _data_author;
                    return data === null || data === void 0 ? void 0 : (_data_author = data.author) === null || _data_author === void 0 ? void 0 : _data_author.display_name;
                },
                slug: "author_name"
            },
            {
                label: "Page author email addresses",
                marshall: function(data) {
                    var _data_author_email_addresses, _data_author;
                    return data === null || data === void 0 ? void 0 : (_data_author = data.author) === null || _data_author === void 0 ? void 0 : (_data_author_email_addresses = _data_author.email_addresses) === null || _data_author_email_addresses === void 0 ? void 0 : _data_author_email_addresses.join(",");
                },
                slug: "author_email_addresses"
            },
            {
                label: "Page Created at",
                slug: "created_at"
            },
            {
                label: "Number of comments",
                marshall: function(data) {
                    return data === null || data === void 0 ? void 0 : data.comments.length;
                },
                slug: "number_of_comments"
            }
        ],
        query: "query ExportEntities {\n        pages {\n          id\n          title\n          author {\n            id\n            display_name\n            email_addresses\n          }\n          primary_entity {\n            id\n            type\n            person {\n              id\n              display_name\n            }\n            team {\n              id\n              name\n            }\n            entity_instance {\n              id\n              display_name\n            }\n          }\n          comments {\n            id\n          }\n          created_at\n          updated_at\n        }\n      }"
    },
    tasks: {
        fields: [
            {
                label: "Unique id",
                slug: "id"
            },
            {
                label: "Name",
                slug: "name"
            },
            {
                label: "Parent item unique id",
                marshall: function(data) {
                    var _data_primary_entity;
                    return data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.id;
                },
                slug: "parent_item_unique_id"
            },
            {
                label: "Parent item unique name",
                marshall: function(data) {
                    var _data_primary_entity;
                    var name;
                    switch(data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.type){
                        case "entity_instances":
                            name = data.primary_entity.entity_instance.display_name;
                            break;
                        case "people":
                            name = data.primary_entity.person.display_name;
                            break;
                        case "teams":
                            name = data.primary_entity.team.name;
                            break;
                        default:
                            break;
                    }
                    return name;
                },
                slug: "parent_item_unique_name"
            },
            {
                label: "Parent item type",
                marshall: function(data) {
                    var _data_primary_entity;
                    return data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.type;
                },
                slug: "parent_item_type"
            },
            {
                label: "Task owner name",
                marshall: function(data) {
                    var _data_author;
                    return data === null || data === void 0 ? void 0 : (_data_author = data.author) === null || _data_author === void 0 ? void 0 : _data_author.display_name;
                },
                slug: "owner_name"
            },
            {
                label: "Task owner email",
                marshall: function(data) {
                    var _data_author_email_addresses, _data_author;
                    return data === null || data === void 0 ? void 0 : (_data_author = data.author) === null || _data_author === void 0 ? void 0 : (_data_author_email_addresses = _data_author.email_addresses) === null || _data_author_email_addresses === void 0 ? void 0 : _data_author_email_addresses.join(",");
                },
                slug: "owner_email_addresses"
            },
            {
                label: "Task Last Updated at",
                slug: "updated_at"
            },
            {
                label: "Task Created at",
                slug: "created_at"
            },
            {
                label: "Task Start date",
                slug: "start_date"
            },
            {
                label: "Task End date",
                slug: "due_date"
            },
            {
                label: "Task Status",
                slug: "status"
            },
            {
                label: "Size",
                slug: "estimate"
            },
            {
                label: "Priority",
                slug: "priority"
            },
            {
                label: "Labels",
                marshall: function(data) {
                    var _data_labels_map, _data_labels;
                    return data === null || data === void 0 ? void 0 : (_data_labels = data.labels) === null || _data_labels === void 0 ? void 0 : (_data_labels_map = _data_labels.map(function(l) {
                        return l.name;
                    })) === null || _data_labels_map === void 0 ? void 0 : _data_labels_map.join(",");
                },
                slug: "labels"
            }
        ],
        query: "query ExportEntities {\n        tasks {\n          id\n          name\n          author {\n            id\n            display_name\n            email_addresses\n          }\n          primary_entity {\n            id\n            type\n            person {\n              id\n              display_name\n            }\n            team {\n              id\n              name\n            }\n            entity_instance {\n              id\n              display_name\n            }\n          }\n          status\n          estimate\n          priority\n          start_date\n          due_date\n          labels {\n            id\n            name\n          }\n          created_at\n          updated_at\n        }\n      }"
    },
    threads: {
        fields: [
            {
                label: "Unique id",
                slug: "id"
            },
            {
                label: "Title",
                slug: "title"
            },
            {
                label: "Parent item unique id",
                marshall: function(data) {
                    var _data_primary_entity;
                    return data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.id;
                },
                slug: "parent_item_unique_id"
            },
            {
                label: "Parent item unique name",
                marshall: function(data) {
                    var _data_primary_entity;
                    var name;
                    switch(data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.type){
                        case "entity_instances":
                            name = data.primary_entity.entity_instance.display_name;
                            break;
                        case "people":
                            name = data.primary_entity.person.display_name;
                            break;
                        case "teams":
                            name = data.primary_entity.team.name;
                            break;
                        default:
                            break;
                    }
                    return name;
                },
                slug: "parent_item_unique_name"
            },
            {
                label: "Parent item type",
                marshall: function(data) {
                    var _data_primary_entity;
                    return data === null || data === void 0 ? void 0 : (_data_primary_entity = data.primary_entity) === null || _data_primary_entity === void 0 ? void 0 : _data_primary_entity.type;
                },
                slug: "parent_item_type"
            },
            {
                label: "Thread author name",
                marshall: function(data) {
                    var _data_author;
                    return data === null || data === void 0 ? void 0 : (_data_author = data.author) === null || _data_author === void 0 ? void 0 : _data_author.display_name;
                },
                slug: "author_name"
            },
            {
                label: "Thread author email addresses",
                marshall: function(data) {
                    var _data_author_email_addresses, _data_author;
                    return data === null || data === void 0 ? void 0 : (_data_author = data.author) === null || _data_author === void 0 ? void 0 : (_data_author_email_addresses = _data_author.email_addresses) === null || _data_author_email_addresses === void 0 ? void 0 : _data_author_email_addresses.join(",");
                },
                slug: "author_email_addresses"
            },
            {
                label: "Thread Last Updated at",
                slug: "updated_at"
            },
            {
                label: "Thread Created at",
                slug: "created_at"
            },
            {
                label: "Thread published at",
                slug: "published_at"
            },
            {
                label: "Requires resolution",
                slug: "needs_resolution"
            },
            {
                label: "Resolved at",
                slug: "closed_at"
            },
            {
                label: "Number of comments",
                marshall: function(data) {
                    return data === null || data === void 0 ? void 0 : data.count_items;
                },
                slug: "number_of_comments"
            },
            {
                label: "Read by count",
                marshall: function(data) {
                    var _data_reaction_count;
                    var readReaction = data === null || data === void 0 ? void 0 : (_data_reaction_count = data.reaction_count) === null || _data_reaction_count === void 0 ? void 0 : _data_reaction_count.find(function(rc) {
                        return rc.value === "read";
                    });
                    return (readReaction === null || readReaction === void 0 ? void 0 : readReaction.count) || 0;
                },
                slug: "count_read_by"
            }
        ],
        query: "query ExportEntities {\n        threads {\n          id\n          title\n          author {\n            id\n            display_name\n            email_addresses\n          }\n          primary_entity {\n            id\n            type\n            person {\n              id\n              display_name\n            }\n            team {\n              id\n              name\n            }\n            entity_instance {\n              id\n              display_name\n            }\n          }\n          count_items\n          needs_resolution\n          published_at\n          closed_at\n          reaction_count {\n            value\n            count\n          }\n          created_at\n          updated_at\n        }\n      }"
    }
};
var exports_default = {
    ENTITIES_EXPORT_MAPPINGS: ENTITIES_EXPORT_MAPPINGS
};
// src/integrations/index.js
var integrations_exports = {};
__export(integrations_exports, {
    asana: function() {
        return asana;
    }
});
var asana = (init_asana(), __toCommonJS(asana_exports));
// src/measurements.js
var measurements_exports = {};
__export(measurements_exports, {
    measurements: function() {
        return measurements;
    }
});
var measurements = {
    boolean: "boolean",
    currency: "currency",
    number: "number",
    percentage: "percentage",
    task: "task"
};
// src/names.js
var PROJECT_STATUSES = {
    at_risk: "At risk",
    completed: "Completed",
    on_hold: "On hold",
    on_track: "On track",
    setup: "Setup"
};
var PAGES_IMPORT_JOB_SOURCES = {
    confluence: "Confluence"
};
var IMPORT_JOB_SOURCES = {
    active_directory: "Active Directory",
    bamboo_hr: "Bamboo HR",
    okta: "Okta"
};
var SEARCH_SORTING_TYPES = {
    recent_created: "Created Date",
    recent_updated: "Last Updated",
    relevant: "Relevance"
};
var TASK_STATUSES = {
    completed: "Completed",
    in_progress: "In progress",
    open: "Not started"
};
var TASK_ESTIMATES = {
    l: "Big",
    m: "Medium",
    s: "Small"
};
var TASK_PRIORITIES = {
    high: "High",
    low: "Low",
    medium: "Medium",
    urgent: "Urgent"
};
var DEFAULT_THREAD_TYPES = {
    announcement: "Announcement",
    blocker: "Blocker",
    decision: "Decision",
    discussion: "Discussion",
    feedback: "Feedback",
    milestone: "Milestone",
    progress: "Progress",
    request: "Request"
};
var names_default = {
    DEFAULT_THREAD_TYPES: DEFAULT_THREAD_TYPES,
    IMPORT_JOB_SOURCES: IMPORT_JOB_SOURCES,
    PAGES_IMPORT_JOB_SOURCES: PAGES_IMPORT_JOB_SOURCES,
    PROJECT_STATUSES: PROJECT_STATUSES,
    SEARCH_SORTING_TYPES: SEARCH_SORTING_TYPES,
    TASK_ESTIMATES: TASK_ESTIMATES,
    TASK_PRIORITIES: TASK_PRIORITIES,
    TASK_STATUSES: TASK_STATUSES,
    displayName: function displayName(entityType) {
        switch(entityType){
            case "update":
                return "post";
            case "updates":
                return "posts";
            case "workflow_item":
                return "workflow step";
            case "workflow_items":
                return "workflow steps";
            case "workflow_assignment":
                return "assignment";
            case "workflow_assignments":
                return "assignments";
            case "workflow_assignment_item":
                return "assignment step";
            case "workflow_assignment_items":
                return "assignment steps";
            case "entity_instances":
                return "items";
            case "entity_instance":
                return "item";
            default:
                return entityType;
        }
    },
    getDisplayName: function getDisplayName(user) {
        var preferred_name = user.preferred_name;
        var result = preferred_name === null || preferred_name === void 0 ? void 0 : preferred_name.trim();
        if (result) {
            return result;
        }
        var first_name = user.first_name, last_name = user.last_name;
        first_name = first_name === null || first_name === void 0 ? void 0 : first_name.trim();
        last_name = last_name === null || last_name === void 0 ? void 0 : last_name.trim();
        if (first_name || last_name) {
            return "".concat(first_name !== null && first_name !== void 0 ? first_name : "", " ").concat(last_name !== null && last_name !== void 0 ? last_name : "").trim();
        }
        return user.email_address.split("@")[0].trim();
    },
    nameAccessor: function nameAccessor(entityType) {
        switch(entityType){
            case "pages":
            case "threads":
            case "updates":
                return "title";
            case "entity_instances":
            case "people":
                return "display_name";
            case "departments":
            case "groups":
            case "projects":
            case "resources":
            case "tasks":
            case "teams":
            case "workflow_assignments":
            case "workflows":
                return "name";
        }
    },
    plural: function plural(entityType) {
        if (!entityType) {
            return;
        }
        switch(entityType){
            case "org":
                return entityType;
            case "person":
                return "people";
            default:
                if (entityType.endsWith("y")) {
                    return "".concat(entityType.slice(0, -1), "ies");
                }
                return "".concat(entityType, "s");
        }
    },
    projectStatus: function projectStatus(status) {
        if (status === "archived") {
            return "Archived";
        }
        return PROJECT_STATUSES[status];
    },
    searchSorting: function searchSorting(sort) {
        return sort ? SEARCH_SORTING_TYPES[sort] : "Default";
    },
    singular: function singular(entityType) {
        if (!entityType) {
            return;
        }
        switch(entityType){
            case "people":
                return "person";
            default:
                if (entityType.endsWith("ies")) {
                    return entityType.replace(/ies$/, "y");
                }
                return entityType.replace(/s$/, "");
        }
    },
    taskEstimate: function taskEstimate(estimate) {
        return estimate ? TASK_ESTIMATES[estimate] : "None";
    },
    taskPriority: function taskPriority(priority) {
        return priority ? TASK_PRIORITIES[priority] : "None";
    },
    taskStatus: function taskStatus(status) {
        return TASK_STATUSES[status];
    }
};
// src/paths.js
var DUMMY_BASE_URL = "https://dummy.site";
var NO_PARENT_PATH_ENTITIES = /* @__PURE__ */ new Set([
    "pages",
    "posts",
    "updates"
]);
var entityUrlCategory = {
    org: "company",
    pages: "pages",
    people: "company",
    posts: "posts",
    projects: "projects",
    tasks: "tasks",
    teams: "company",
    updates: "posts",
    workflow_assignments: "workflows",
    workflows: "workflows"
};
var entityUrlCategoryInTeams = {
    home: "",
    pages: "pages",
    posts: "posts",
    projects: "projects",
    resources: "resources",
    tasks: "tasks",
    threads: "threads",
    updates: "posts",
    workflow_assignments: "workflows",
    workflows: "workflows"
};
var entityTypePath = {
    org: "home",
    pages: null,
    people: "people",
    projects: null,
    teams: "teams",
    updates: null,
    workflow_assignments: "assignments",
    workflows: "workflow"
};
var entityIdentifier = {
    org: "slug",
    pages: "id",
    people: "slug",
    posts: "id",
    projects: "slug",
    tasks: "number",
    teams: "slug",
    updates: "id",
    workflow_assignments: "id",
    workflows: "slug"
};
var LOGIN_ROUTE = "/login";
var paths_default = {
    LOGIN_ROUTE: LOGIN_ROUTE,
    assignments: function assignments(workflow) {
        return "".concat(this.entity(workflow, "workflows"), "/assignments");
    },
    comment: function comment(comment, entity, entityType, parentEntity, parentEntityType) {
        var entityPath = this.entity(entity, entityType, parentEntity, parentEntityType);
        var dummyURL = new URL(entityPath, DUMMY_BASE_URL);
        if (comment.parent_comment_id) {
            dummyURL.searchParams.append("comment", comment.parent_comment_id);
            dummyURL.searchParams.append("reply", comment.id);
            return "".concat(dummyURL.pathname).concat(dummyURL.search);
        }
        dummyURL.searchParams.append("comment", comment.id);
        if (comment.reply) {
            dummyURL.searchParams.append("reply", comment.reply.id);
        }
        return "".concat(dummyURL.pathname).concat(dummyURL.search);
    },
    /**
   * Populate the proper url of the entity.
   * @param {object} entity: entity object
   * @param {string} type: entity type
   * @param {string} [parentEntity]: parent entity object
   * @param {string} [parentEntityType]: parent entity type
   */ entity: function entity(entity, type, parentEntity, parentEntityType) {
        if (NO_PARENT_PATH_ENTITIES.has(type)) {
            return "/".concat(entityUrlCategory[type], "/").concat(entity[entityIdentifier[type]]);
        }
        var _this_entityOverview, _parentEntity_entityIdentifier_parentEntityType;
        var parentPath = "".concat((_this_entityOverview = this.entityOverview(parentEntityType)) !== null && _this_entityOverview !== void 0 ? _this_entityOverview : "/t", "/").concat((_parentEntity_entityIdentifier_parentEntityType = parentEntity === null || parentEntity === void 0 ? void 0 : parentEntity[entityIdentifier === null || entityIdentifier === void 0 ? void 0 : entityIdentifier[parentEntityType]]) !== null && _parentEntity_entityIdentifier_parentEntityType !== void 0 ? _parentEntity_entityIdentifier_parentEntityType : "".concat(parentEntityType, "/").concat(parentEntity === null || parentEntity === void 0 ? void 0 : parentEntity.id));
        if (type === "tasks") {
            if (entity[entityIdentifier[type]]) {
                return "/".concat(entityUrlCategory[type], "/").concat(entity[entityIdentifier[type]]);
            }
            if (parentEntityType === "tasks") {
                return parentPath;
            }
            return "".concat(parentPath, "/tasks");
        }
        if (type === "entity_instances") {
            return "/t/".concat(entity.type, "/").concat(entity.id);
        }
        if (type === "threads") {
            return "/threads/".concat(entity.id);
        }
        if (type === "thread_items") {
            return "/threads/".concat(entity.thread_id, "?ItemId=").concat(entity.id);
        }
        if (type === "workflow_items" || type === "workflow_assignment_items") {
            return "".concat(parentPath, "?step=").concat(entity.id);
        }
        var entityOverviewPath = this.entityOverview(type);
        if (entityOverviewPath) {
            return "".concat(entityOverviewPath, "/").concat((entity === null || entity === void 0 ? void 0 : entity[entityIdentifier === null || entityIdentifier === void 0 ? void 0 : entityIdentifier[type]]) || "");
        }
        return "/t/".concat(type, "/").concat(entity === null || entity === void 0 ? void 0 : entity.id);
    },
    entityOverview: function entityOverview(type) {
        var typePath = entityTypePath[type];
        var typePathUrl = typePath ? "/".concat(typePath) : "";
        var entityCategory = entityUrlCategory[type];
        if (entityCategory) {
            return "/".concat(entityCategory).concat(typePathUrl);
        }
        if (typePathUrl) {
            return "/".concat(typePathUrl);
        }
    },
    entityOverviewInTeam: function entityOverviewInTeam(teamSlug, type) {
        var typePath = entityUrlCategoryInTeams[type];
        return "".concat(this.entityOverview("teams"), "/").concat(teamSlug, "/").concat(typePath);
    },
    integrations: function integrations() {
        return "/integrations";
    },
    /**
   * URL to invite user to qatalog with entity campaign
   * @param {string} type type of invite campaign
   * @returns invite url
   */ inviteLogin: function inviteLogin(type) {
        return "".concat(LOGIN_ROUTE, "?utm_medium=email&utm_campaign=").concat(type, "-invite");
    },
    notificationSettings: function notificationSettings() {
        return "/settings/notifications";
    },
    workflows: function workflows() {
        var subpath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return "/workflows".concat(subpath);
    }
};
// src/payload-limits.js
var KILOBYTE = 1024;
var MEGABYTE = KILOBYTE * KILOBYTE;
var payload_limits_default = {
    analytics: 32 * KILOBYTE,
    default_limit: MEGABYTE,
    files: 512 * MEGABYTE,
    images: 8 * MEGABYTE,
    import_csv_files: 50 * MEGABYTE,
    posts: 2 * MEGABYTE,
    workflow_items: 50 * MEGABYTE
};
// src/permissions.js
var ROLES = [
    "viewer",
    "member",
    "admin",
    "owner"
];
var permissions_default = {
    PRECEDENCE: ROLES.reduce(function(p, role, index) {
        return _object_spread_props(_object_spread({}, p), _define_property({}, role, index));
    }, {}),
    ROLES: ROLES
};
// src/personal-email-domains.json
var personal_email_domains_default = [
    "10mail.com",
    "10mail.org",
    "10minutemail.be",
    "10minutemail.cf",
    "10minutemail.co.uk",
    "10minutemail.co.za",
    "10minutemail.com",
    "10minutemail.de",
    "10minutemail.fr",
    "10minutemail.ga",
    "10minutemail.gq",
    "10minutemail.info",
    "10minutemail.ml",
    "10minutemail.net",
    "10minutemail.nl",
    "10minutemail.org",
    "10minutemail.ru",
    "10minutemail.us",
    "12minutemail.com",
    "12minutemail.net",
    "163.com",
    "188.com",
    "189.cn",
    "1mail.ml",
    "1mail.net",
    "1secmail.com",
    "1secmail.net",
    "1secmail.org",
    "1secmail.xyz",
    "20email.eu",
    "20email.it",
    "20mail.it",
    "20mail.in",
    "20mail.eu",
    "20minutemail.com",
    "20minutemail.it",
    "675hosting.com",
    "675hosting.net",
    "675hosting.org",
    "altavista.com",
    "altavista.net",
    "altavista.se",
    "ac.com",
    "ac.dk",
    "ac.jp",
    "ac.net",
    "ac.org",
    "ac.ru",
    "antispam.de",
    "antispam24.de",
    "antispammail.de",
    "aol.co.uk",
    "aol.com",
    "aol.it",
    "blueyonder.co.uk",
    "btconnect.com",
    "btinternet.com",
    "btopenworld.co.uk",
    "btopenworld.com",
    "chat.ru",
    "cicciociccio.com",
    "college.com",
    "college.dk",
    "college.jp",
    "college.net",
    "college.org",
    "college.ru",
    "comcast.net",
    "discard-email.cf",
    "discard.cf",
    "discard.email",
    "discard.ga",
    "discard.gq",
    "discard.ml",
    "discard.tk",
    "discardmail.com",
    "discardmail.de",
    "domforfb1.tk",
    "domforfb18.tk",
    "domforfb19.tk",
    "domforfb2.tk",
    "domforfb23.tk",
    "domforfb27.tk",
    "domforfb29.tk",
    "domforfb3.tk",
    "domforfb4.tk",
    "domforfb5.tk",
    "domforfb6.tk",
    "domforfb7.tk",
    "domforfb8.tk",
    "domforfb9.tk",
    "e-mail.com",
    "e-mail.dk",
    "e-mail.jp",
    "e-mail.net",
    "e-mail.org",
    "e-mail.ru",
    "e-mailanywhere.com",
    "e-mails.ru",
    "edu.com",
    "edu.dk",
    "edu.jp",
    "edu.net",
    "edu.org",
    "edu.ru",
    "email-fake.cf",
    "email-fake.com",
    "email-fake.ga",
    "email-fake.gq",
    "email-fake.ml",
    "email-fake.tk",
    "email.com",
    "email.cz",
    "email.de",
    "email.dk",
    "email.ee",
    "email.it",
    "email.net",
    "email.nu",
    "email.ro",
    "email.ru",
    "email.si",
    "emailspam.cf",
    "emailspam.ga",
    "emailspam.gq",
    "emailspam.ml",
    "emailspam.tk",
    "emailz.cf",
    "emailz.ga",
    "emailz.gq",
    "emailz.ml",
    "fake-mail.cf",
    "fake-mail.ga",
    "fake-mail.gq",
    "fake-mail.ml",
    "fake-mail.tk",
    "fakeinbox.cf",
    "fakeinbox.com",
    "fakeinbox.ga",
    "fakeinbox.info",
    "fakeinbox.ml",
    "fakeinbox.tk",
    "fakemail.win",
    "fakemails.cf",
    "fakemails.ga",
    "fakemails.gq",
    "fakemails.ml",
    "fakemailz.com",
    "fastmail.com.au",
    "fastmail.fm",
    "freemail.com.au",
    "freemail.com.pk",
    "freemail.de",
    "freemail.et",
    "freemail.gr",
    "freemail.hu",
    "freemail.it",
    "freemail.lt",
    "freemail.ms",
    "freemail.nl",
    "gmail.com",
    "gmail.ad",
    "gmail.ae",
    "gmail.com.af",
    "gmail.com.ag",
    "gmail.al",
    "gmail.am",
    "gmail.co.ao",
    "gmail.com.ar",
    "gmail.as",
    "gmail.at",
    "gmail.com.au",
    "gmail.az",
    "gmail.ba",
    "gmail.com.bd",
    "gmail.be",
    "gmail.bf",
    "gmail.bg",
    "gmail.com.bh",
    "gmail.bi",
    "gmail.bj",
    "gmail.com.bn",
    "gmail.com.bo",
    "gmail.com.br",
    "gmail.bs",
    "gmail.bt",
    "gmail.co.bw",
    "gmail.by",
    "gmail.com.bz",
    "gmail.ca",
    "gmail.cd",
    "gmail.cf",
    "gmail.cg",
    "gmail.ch",
    "gmail.ci",
    "gmail.co.ck",
    "gmail.cl",
    "gmail.cm",
    "gmail.cn",
    "gmail.com.co",
    "gmail.co.cr",
    "gmail.com.cu",
    "gmail.cv",
    "gmail.com.cy",
    "gmail.cz",
    "gmail.de",
    "gmail.dj",
    "gmail.dk",
    "gmail.dm",
    "gmail.com.do",
    "gmail.dz",
    "gmail.com.ec",
    "gmail.ee",
    "gmail.com.eg",
    "gmail.es",
    "gmail.com.et",
    "gmail.fi",
    "gmail.com.fj",
    "gmail.fm",
    "gmail.fr",
    "gmail.ga",
    "gmail.ge",
    "gmail.gg",
    "gmail.com.gh",
    "gmail.com.gi",
    "gmail.gl",
    "gmail.gm",
    "gmail.gr",
    "gmail.com.gt",
    "gmail.gy",
    "gmail.com.hk",
    "gmail.hn",
    "gmail.hr",
    "gmail.ht",
    "gmail.hu",
    "gmail.co.id",
    "gmail.ie",
    "gmail.co.il",
    "gmail.im",
    "gmail.co.in",
    "gmail.iq",
    "gmail.is",
    "gmail.it",
    "gmail.je",
    "gmail.com.jm",
    "gmail.jo",
    "gmail.co.jp",
    "gmail.co.ke",
    "gmail.com.kh",
    "gmail.ki",
    "gmail.kg",
    "gmail.co.kr",
    "gmail.com.kw",
    "gmail.kz",
    "gmail.la",
    "gmail.com.lb",
    "gmail.li",
    "gmail.lk",
    "gmail.co.ls",
    "gmail.lt",
    "gmail.lu",
    "gmail.lv",
    "gmail.com.ly",
    "gmail.co.ma",
    "gmail.md",
    "gmail.me",
    "gmail.mg",
    "gmail.mk",
    "gmail.ml",
    "gmail.com.mm",
    "gmail.mn",
    "gmail.com.mt",
    "gmail.mu",
    "gmail.mv",
    "gmail.mw",
    "gmail.com.mx",
    "gmail.com.my",
    "gmail.co.mz",
    "gmail.com.na",
    "gmail.com.ng",
    "gmail.com.ni",
    "gmail.ne",
    "gmail.nl",
    "gmail.no",
    "gmail.com.np",
    "gmail.nr",
    "gmail.nu",
    "gmail.co.nz",
    "gmail.com.om",
    "gmail.com.pa",
    "gmail.com.pe",
    "gmail.com.pg",
    "gmail.com.ph",
    "gmail.com.pk",
    "gmail.pl",
    "gmail.pn",
    "gmail.com.pr",
    "gmail.ps",
    "gmail.pt",
    "gmail.com.py",
    "gmail.com.qa",
    "gmail.ro",
    "gmail.ru",
    "gmail.rw",
    "gmail.com.sa",
    "gmail.com.sb",
    "gmail.sc",
    "gmail.se",
    "gmail.com.sg",
    "gmail.sh",
    "gmail.si",
    "gmail.sk",
    "gmail.com.sl",
    "gmail.sn",
    "gmail.so",
    "gmail.sm",
    "gmail.sr",
    "gmail.st",
    "gmail.com.sv",
    "gmail.td",
    "gmail.tg",
    "gmail.co.th",
    "gmail.com.tj",
    "gmail.tl",
    "gmail.tm",
    "gmail.tn",
    "gmail.to",
    "gmail.com.tr",
    "gmail.tt",
    "gmail.com.tw",
    "gmail.co.tz",
    "gmail.com.ua",
    "gmail.co.ug",
    "gmail.co.uk",
    "gmail.com.uy",
    "gmail.co.uz",
    "gmail.com.vc",
    "gmail.co.ve",
    "gmail.co.vi",
    "gmail.com.vn",
    "gmail.vu",
    "gmail.ws",
    "gmail.rs",
    "gmail.co.za",
    "gmail.co.zm",
    "gmail.co.zw",
    "gmail.cat",
    "gmx.at",
    "gmx.ch",
    "gmx.com",
    "gmx.de",
    "gmx.fr",
    "gmx.li",
    "gmx.net",
    "googlemail.com",
    "guerrillamail.biz",
    "guerrillamail.com",
    "guerrillamail.de",
    "guerrillamail.info",
    "guerrillamail.net",
    "guerrillamail.org",
    "guerrillamailblock.com",
    "gynzi.co.uk",
    "gynzi.es",
    "gynzy.at",
    "gynzy.es",
    "gynzy.eu",
    "gynzy.gr",
    "gynzy.info",
    "gynzy.lt",
    "gynzy.mobi",
    "gynzy.pl",
    "gynzy.ro",
    "gynzy.sk",
    "hidemail.de",
    "hidemail.pro",
    "hidemail.us",
    "hot-mail.cf",
    "hot-mail.ga",
    "hot-mail.gq",
    "hot-mail.ml",
    "hot-mail.tk",
    "hotmail.be",
    "hotmail.ca",
    "hotmail.ch",
    "hotmail.cn",
    "hotmail.co.il",
    "hotmail.co.jp",
    "hotmail.co.kr",
    "hotmail.co.nz",
    "hotmail.co.th",
    "hotmail.co.uk",
    "hotmail.com",
    "hotmail.com.ar",
    "hotmail.com.au",
    "hotmail.com.br",
    "hotmail.com.mx",
    "hotmail.de",
    "hotmail.dk",
    "hotmail.es",
    "hotmail.fr",
    "hotmail.gr",
    "hotmail.it",
    "hotmail.kg",
    "hotmail.kz",
    "hotmail.nl",
    "hotmail.ru",
    "hotmail.se",
    "hotmail.sg",
    "hotpop.com",
    "hotpop3.com",
    "i-3gk.cf",
    "i-3gk.ga",
    "i-3gk.gq",
    "i-3gk.ml",
    "icloud.com",
    "imail.org",
    "imail.ru",
    "imailbox.com",
    "inbound.dk",
    "inbound.plus",
    "inbox.com",
    "inbox.lv",
    "inbox.net",
    "inbox.ru",
    "inbox.si",
    "inbox2.info",
    "incognitomail.com",
    "incognitomail.net",
    "incognitomail.org",
    "inmynetwork.cf",
    "inmynetwork.ga",
    "inmynetwork.gq",
    "inmynetwork.ml",
    "inmynetwork.tk",
    "inoutmail.de",
    "inoutmail.eu",
    "inoutmail.info",
    "inoutmail.net",
    "linuxmail.com",
    "linuxmail.org",
    "linuxmail.so",
    "linuxmail.tk",
    "list.ru",
    "live.be",
    "live.ca",
    "live.cl",
    "live.cn",
    "live.co.kr",
    "live.co.uk",
    "live.com",
    "live.com.ar",
    "live.com.au",
    "live.com.mx",
    "live.com.pt",
    "live.com.sg",
    "live.de",
    "live.dk",
    "live.fr",
    "live.hk",
    "live.ie",
    "live.in",
    "live.it",
    "live.jp",
    "live.nl",
    "lycos.at",
    "lycos.co.uk",
    "lycos.com",
    "lycos.de",
    "lycos.es",
    "lycos.it",
    "lycos.ne.jp",
    "lycos.nl",
    "lycosemail.com",
    "lycosmail.com",
    "mail.az",
    "mail.be",
    "mail.bg",
    "mail.by",
    "mail.co.za",
    "mail.com",
    "mail.dk",
    "mail.ee",
    "mail.gr",
    "mail.ie",
    "mail.mailinator.com",
    "mail.md",
    "mail.me",
    "mail.ne",
    "mail.org.uk",
    "mail.pf",
    "mail.pt",
    "mail.ru",
    "mail.wtf",
    "mailinator.co.uk",
    "mailinator.com",
    "mailinator.gq",
    "mailinator.info",
    "mailinator.net",
    "mailinator.org",
    "mailinator.pl",
    "mailinator.us",
    "mailjunk.cf",
    "mailjunk.ga",
    "mailjunk.gq",
    "mailjunk.ml",
    "mailjunk.tk",
    "mailme.dk",
    "mailme.gq",
    "mailme.ir",
    "mailme.lv",
    "mailme24.com",
    "me.com",
    "msn.cn",
    "msn.co.uk",
    "msn.com",
    "naver.com",
    "nextemail.in",
    "nextemail.net",
    "nextmail.in",
    "nextmail.info",
    "online.de",
    "online.ie",
    "online.ms",
    "orange.fr",
    "orange.net",
    "outlook.at",
    "outlook.be",
    "outlook.cl",
    "outlook.co.id",
    "outlook.co.il",
    "outlook.co.nz",
    "outlook.co.th",
    "outlook.com",
    "outlook.com.ar",
    "outlook.com.au",
    "outlook.com.br",
    "outlook.com.gr",
    "outlook.com.pe",
    "outlook.com.tr",
    "outlook.com.vn",
    "outlook.cz",
    "outlook.de",
    "outlook.dk",
    "outlook.es",
    "outlook.fr",
    "outlook.hu",
    "outlook.ie",
    "outlook.in",
    "outlook.it",
    "outlook.jp",
    "outlook.kr",
    "outlook.lv",
    "outlook.my",
    "outlook.ph",
    "outlook.pt",
    "outlook.sa",
    "outlook.sg",
    "outlook.sk",
    "pm.me",
    "porco.cf",
    "porco.ga",
    "porco.gq",
    "porco.ml",
    "post.com",
    "post.cz",
    "post.sk",
    "posta.net",
    "posta.ro",
    "postafree.com",
    "postaweb.com",
    "poste.it",
    "postemail.net",
    "posteo.af",
    "posteo.at",
    "posteo.be",
    "posteo.ch",
    "posteo.cl",
    "posteo.co",
    "posteo.co.uk",
    "posteo.com.br",
    "posteo.cr",
    "posteo.cz",
    "posteo.de",
    "posteo.dk",
    "posteo.ee",
    "posteo.es",
    "posteo.eu",
    "posteo.fi",
    "posteo.gl",
    "posteo.gr",
    "posteo.hn",
    "posteo.hr",
    "posteo.hu",
    "posteo.ie",
    "posteo.in",
    "posteo.is",
    "posteo.jp",
    "posteo.la",
    "posteo.li",
    "posteo.lt",
    "posteo.lu",
    "posteo.me",
    "posteo.mx",
    "posteo.my",
    "posteo.net",
    "posteo.nl",
    "posteo.no",
    "posteo.nz",
    "posteo.org",
    "posteo.pe",
    "posteo.pl",
    "posteo.pm",
    "posteo.pt",
    "posteo.ro",
    "posteo.ru",
    "posteo.se",
    "posteo.sg",
    "posteo.si",
    "posteo.tn",
    "posteo.uk",
    "posteo.us",
    "proton.me",
    "protonmail.ch",
    "protonmail.com",
    "qq.com",
    "qq.my",
    "quick-mail.club",
    "quick-mail.info",
    "quick-mail.online",
    "quickemail.info",
    "quickemail.top",
    "quickmail.best",
    "quickmail.in",
    "quickmail.nl",
    "quickmail.rocks",
    "sch.com",
    "sch.dk",
    "sch.jp",
    "sch.net",
    "sch.org",
    "sch.ru",
    "sneakemail.com",
    "sneakmail.de",
    "spambob.com",
    "spambob.net",
    "spambob.org",
    "spambog.com",
    "spambog.de",
    "spambog.net",
    "spambog.ru",
    "spambox.me",
    "spambox.org",
    "spambox.us",
    "spambox.xyz",
    "spamcannon.com",
    "spamcannon.net",
    "spamfighter.cf",
    "spamfighter.ga",
    "spamfighter.gq",
    "spamfighter.ml",
    "spamfighter.tk",
    "spamfree.eu",
    "spamfree24.com",
    "spamfree24.de",
    "spamfree24.eu",
    "spamfree24.info",
    "spamfree24.net",
    "spamfree24.org",
    "stop-my-spam.cf",
    "stop-my-spam.com",
    "stop-my-spam.ga",
    "stop-my-spam.ml",
    "stop-my-spam.tk",
    "t-online.de",
    "t-online.hu",
    "talktalk.co.uk",
    "talktalk.net",
    "temp-mail.com",
    "temp-mail.de",
    "temp-mail.live",
    "temp-mail.ml",
    "temp-mail.net",
    "temp-mail.org",
    "temp-mail.ru",
    "tempemail.biz",
    "tempemail.co.za",
    "tempemail.com",
    "tempemail.net",
    "tempemail.org",
    "tempemails.io",
    "tempinbox.co.uk",
    "tempinbox.com",
    "tempmail.co",
    "tempmail.de",
    "tempmail.eu",
    "tempmail.it",
    "tempmail.pro",
    "tempmail.space",
    "tempmail.us",
    "tempmail.win",
    "tempmailer.com",
    "tempmailer.de",
    "tiscali.at",
    "tiscali.be",
    "tiscali.co.uk",
    "tiscali.it",
    "tiscali.lu",
    "tiscali.se",
    "trash-mail.at",
    "trash-mail.cf",
    "trash-mail.com",
    "trash-mail.de",
    "trash-mail.ga",
    "trash-mail.gq",
    "trash-mail.ml",
    "trash-mail.net",
    "trash-mail.tk",
    "trashmail.at",
    "trashmail.com",
    "trashmail.de",
    "trashmail.gq",
    "trashmail.io",
    "trashmail.me",
    "trashmail.net",
    "trashmail.org",
    "trashmail.ws",
    "trashmailer.com",
    "web.de",
    "web-mail.de",
    "yahoo.ca",
    "yahoo.cn",
    "yahoo.co.id",
    "yahoo.co.in",
    "yahoo.co.jp",
    "yahoo.co.kr",
    "yahoo.co.nz",
    "yahoo.co.th",
    "yahoo.co.uk",
    "yahoo.com",
    "yahoo.com.ar",
    "yahoo.com.asia",
    "yahoo.com.au",
    "yahoo.com.br",
    "yahoo.com.cn",
    "yahoo.com.es",
    "yahoo.com.hk",
    "yahoo.com.is",
    "yahoo.com.mx",
    "yahoo.com.my",
    "yahoo.com.ph",
    "yahoo.com.ru",
    "yahoo.com.sg",
    "yahoo.com.tw",
    "yahoo.com.vn",
    "yahoo.de",
    "yahoo.dk",
    "yahoo.es",
    "yahoo.fr",
    "yahoo.gr",
    "yahoo.ie",
    "yahoo.in",
    "yahoo.it",
    "yahoo.jp",
    "yahoo.om",
    "yahoo.ro",
    "yahoo.ru",
    "yahoo.se",
    "ymail.ca",
    "ymail.cn",
    "ymail.co.id",
    "ymail.co.in",
    "ymail.co.jp",
    "ymail.co.kr",
    "ymail.co.nz",
    "ymail.co.th",
    "ymail.co.uk",
    "ymail.com",
    "ymail.com.ar",
    "ymail.com.asia",
    "ymail.com.au",
    "ymail.com.br",
    "ymail.com.cn",
    "ymail.com.es",
    "ymail.com.hk",
    "ymail.com.is",
    "ymail.com.mx",
    "ymail.com.my",
    "ymail.com.ph",
    "ymail.com.ru",
    "ymail.com.sg",
    "ymail.com.tw",
    "ymail.com.vn",
    "ymail.de",
    "ymail.dk",
    "ymail.es",
    "ymail.fr",
    "ymail.gr",
    "ymail.ie",
    "ymail.in",
    "ymail.it",
    "ymail.jp",
    "ymail.om",
    "ymail.ro",
    "ymail.ru",
    "ymail.se",
    "yandex.com",
    "yandex.ru"
];
// src/posts.js
var posts_exports = {};
__export(posts_exports, {
    types: function() {
        return types;
    }
});
var types = [
    "Announcement",
    "Alert",
    "Milestone",
    "Progress",
    "Blocker"
];
// src/schemata.js
var schemata_default = function(joi) {
    return {
        tipTapObject: joi.object({
            content: joi.array().items(joi.object({
                attrs: joi.object().optional(),
                content: joi.array().items(joi.link("#tipTapContent")),
                marks: joi.array().items(joi.object()).optional(),
                text: joi.string().optional(),
                type: joi.string().required()
            }).id("tipTapContent")),
            type: joi.string().required()
        })
    };
};
// src/tiptap/index.js
import { generateHTML, generateJSON } from "@tiptap/html";
import { Document } from "@tiptap/extension-document";
import { Text } from "@tiptap/extension-text";
import { TextStyle } from "@tiptap/extension-text-style";
import { Typography } from "@tiptap/extension-typography";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import { Underline } from "@tiptap/extension-underline";
import { Strike } from "@tiptap/extension-strike";
import { Code } from "@tiptap/extension-code";
import { Highlight } from "@tiptap/extension-highlight";
import { Subscript } from "@tiptap/extension-subscript";
import { Superscript } from "@tiptap/extension-superscript";
import { Link } from "@tiptap/extension-link";
import { ListItem } from "@tiptap/extension-list-item";
import { HardBreak } from "@tiptap/extension-hard-break";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Heading } from "@tiptap/extension-heading";
import { Blockquote } from "@tiptap/extension-blockquote";
import { CodeBlockLowlight } from "@tiptap/extension-code-block-lowlight";
import { HorizontalRule } from "@tiptap/extension-horizontal-rule";
import { BulletList } from "@tiptap/extension-bullet-list";
import { OrderedList } from "@tiptap/extension-ordered-list";
import { TextAlign } from "@tiptap/extension-text-align";
import { Image } from "@tiptap/extension-image";
import { Table } from "@tiptap/extension-table";
import { TableRow } from "@tiptap/extension-table-row";
import { TableHeader } from "@tiptap/extension-table-header";
import { TableCell } from "@tiptap/extension-table-cell";
// ../../node_modules/.pnpm/lowlight@2.9.0/node_modules/lowlight/lib/common.js
import arduino from "highlight.js/lib/languages/arduino";
import bash from "highlight.js/lib/languages/bash";
import c from "highlight.js/lib/languages/c";
import cpp from "highlight.js/lib/languages/cpp";
import csharp from "highlight.js/lib/languages/csharp";
import css from "highlight.js/lib/languages/css";
import diff from "highlight.js/lib/languages/diff";
import go from "highlight.js/lib/languages/go";
import graphql from "highlight.js/lib/languages/graphql";
import ini from "highlight.js/lib/languages/ini";
import java from "highlight.js/lib/languages/java";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import kotlin from "highlight.js/lib/languages/kotlin";
import less from "highlight.js/lib/languages/less";
import lua from "highlight.js/lib/languages/lua";
import makefile from "highlight.js/lib/languages/makefile";
import markdown from "highlight.js/lib/languages/markdown";
import objectivec from "highlight.js/lib/languages/objectivec";
import perl from "highlight.js/lib/languages/perl";
import php from "highlight.js/lib/languages/php";
import phpTemplate from "highlight.js/lib/languages/php-template";
import plaintext from "highlight.js/lib/languages/plaintext";
import python from "highlight.js/lib/languages/python";
import pythonRepl from "highlight.js/lib/languages/python-repl";
import r from "highlight.js/lib/languages/r";
import ruby from "highlight.js/lib/languages/ruby";
import rust from "highlight.js/lib/languages/rust";
import scss from "highlight.js/lib/languages/scss";
import shell from "highlight.js/lib/languages/shell";
import sql from "highlight.js/lib/languages/sql";
import swift from "highlight.js/lib/languages/swift";
import typescript from "highlight.js/lib/languages/typescript";
import vbnet from "highlight.js/lib/languages/vbnet";
import wasm from "highlight.js/lib/languages/wasm";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";
// ../../node_modules/.pnpm/lowlight@2.9.0/node_modules/lowlight/lib/core.js
import high from "highlight.js/lib/core";
// ../../node_modules/.pnpm/fault@2.0.1/node_modules/fault/index.js
var import_format = __toESM(require_format(), 1);
var fault = Object.assign(create(Error), {
    eval: create(EvalError),
    range: create(RangeError),
    reference: create(ReferenceError),
    syntax: create(SyntaxError),
    type: create(TypeError),
    uri: create(URIError)
});
function create(Constructor) {
    FormattedError.displayName = Constructor.displayName || Constructor.name;
    return FormattedError;
    function FormattedError(format) {
        for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            values[_key - 1] = arguments[_key];
        }
        var reason = format ? (0, import_format.default).apply(this, [
            format
        ].concat(_to_consumable_array(values))) : format;
        return new Constructor(reason);
    }
}
// ../../node_modules/.pnpm/lowlight@2.9.0/node_modules/lowlight/lib/core.js
var own = {}.hasOwnProperty;
var defaultPrefix = "hljs-";
function highlight(language, value) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var prefix2 = options.prefix;
    if (typeof language !== "string") {
        throw fault("Expected `string` for name, got `%s`", language);
    }
    if (!high.getLanguage(language)) {
        throw fault("Unknown language: `%s` is not registered", language);
    }
    if (typeof value !== "string") {
        throw fault("Expected `string` for value, got `%s`", value);
    }
    if (prefix2 === null || prefix2 === void 0) {
        prefix2 = defaultPrefix;
    }
    high.configure({
        __emitter: HastEmitter,
        classPrefix: prefix2
    });
    var result = /** @type {HighlightResult & {_emitter: HastEmitter}} */ high.highlight(value, {
        language: language,
        ignoreIllegals: true
    });
    high.configure({});
    if (result.errorRaised) {
        throw result.errorRaised;
    }
    result._emitter.root.data.language = result.language;
    result._emitter.root.data.relevance = result.relevance;
    return result._emitter.root;
}
function highlightAuto(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var subset = options.subset || high.listLanguages();
    var prefix2 = options.prefix;
    var index = -1;
    var result = {
        type: "root",
        data: {
            language: null,
            relevance: 0
        },
        children: []
    };
    if (prefix2 === null || prefix2 === void 0) {
        prefix2 = defaultPrefix;
    }
    if (typeof value !== "string") {
        throw fault("Expected `string` for value, got `%s`", value);
    }
    while(++index < subset.length){
        var name = subset[index];
        if (!high.getLanguage(name)) continue;
        var current = highlight(name, value, options);
        if (current.data.relevance > result.data.relevance) result = current;
    }
    return result;
}
function registerLanguage(language, syntax) {
    high.registerLanguage(language, syntax);
}
var registerAlias = /**
   * @type {(
   *   ((language: string, alias: string|Array<string>) => void) &
   *   ((aliases: Record<string, string|Array<string>>) => void)
   * )}
   */ /**
   * @param {string|Record<string, string|Array<string>>} language
   * @param {string|Array<string>} [alias]
   * @returns {void}
   */ function registerAlias(language, alias) {
    if (typeof language === "string") {
        high.registerAliases(alias, {
            languageName: language
        });
    } else {
        var key;
        for(key in language){
            if (own.call(language, key)) {
                high.registerAliases(language[key], {
                    languageName: key
                });
            }
        }
    }
};
function registered(aliasOrLanguage) {
    return Boolean(high.getLanguage(aliasOrLanguage));
}
function listLanguages() {
    return high.listLanguages();
}
var HastEmitter = /*#__PURE__*/ function() {
    "use strict";
    function HastEmitter(options) {
        _class_call_check(this, HastEmitter);
        this.options = options;
        this.root = {
            type: "root",
            data: {
                language: null,
                relevance: 0
            },
            children: []
        };
        this.stack = [
            this.root
        ];
    }
    _create_class(HastEmitter, [
        {
            /**
   * @param {string} value
   */ key: "addText",
            value: function addText(value) {
                if (value === "") return;
                var current = this.stack[this.stack.length - 1];
                var tail = current.children[current.children.length - 1];
                if (tail && tail.type === "text") {
                    tail.value += value;
                } else {
                    current.children.push({
                        type: "text",
                        value: value
                    });
                }
            }
        },
        {
            /**
   *
   * @param {unknown} rawName
   */ key: "startScope",
            value: function startScope(rawName) {
                this.openNode(String(rawName));
            }
        },
        {
            /**
   */ key: "endScope",
            value: function endScope() {
                this.closeNode();
            }
        },
        {
            /**
   * @param {HastEmitter} other
   * @param {string} name
   */ key: "__addSublanguage",
            value: function __addSublanguage(other, name) {
                var current = this.stack[this.stack.length - 1];
                var results = other.root.children;
                if (name) {
                    current.children.push({
                        type: "element",
                        tagName: "span",
                        properties: {
                            className: [
                                name
                            ]
                        },
                        children: results
                    });
                } else {
                    var _current_children;
                    (_current_children = current.children).push.apply(_current_children, _to_consumable_array(results));
                }
            }
        },
        {
            /**
   * @param {string} name
   */ key: "openNode",
            value: function openNode(name) {
                var _this = this;
                var className = name.split(".").map(function(d, i) {
                    return i ? d + "_".repeat(i) : _this.options.classPrefix + d;
                });
                var current = this.stack[this.stack.length - 1];
                var child = {
                    type: "element",
                    tagName: "span",
                    properties: {
                        className: className
                    },
                    children: []
                };
                current.children.push(child);
                this.stack.push(child);
            }
        },
        {
            /**
   */ key: "closeNode",
            value: function closeNode() {
                this.stack.pop();
            }
        },
        {
            /**
   */ key: "finalize",
            value: function finalize() {}
        },
        {
            /**
   */ key: "toHTML",
            value: function toHTML() {
                return "";
            }
        }
    ]);
    return HastEmitter;
}();
var lowlight = {
    highlight: highlight,
    highlightAuto: highlightAuto,
    registerLanguage: registerLanguage,
    registered: registered,
    listLanguages: listLanguages,
    registerAlias: registerAlias
};
// ../../node_modules/.pnpm/lowlight@2.9.0/node_modules/lowlight/lib/common.js
lowlight.registerLanguage("arduino", arduino);
lowlight.registerLanguage("bash", bash);
lowlight.registerLanguage("c", c);
lowlight.registerLanguage("cpp", cpp);
lowlight.registerLanguage("csharp", csharp);
lowlight.registerLanguage("css", css);
lowlight.registerLanguage("diff", diff);
lowlight.registerLanguage("go", go);
lowlight.registerLanguage("graphql", graphql);
lowlight.registerLanguage("ini", ini);
lowlight.registerLanguage("java", java);
lowlight.registerLanguage("javascript", javascript);
lowlight.registerLanguage("json", json);
lowlight.registerLanguage("kotlin", kotlin);
lowlight.registerLanguage("less", less);
lowlight.registerLanguage("lua", lua);
lowlight.registerLanguage("makefile", makefile);
lowlight.registerLanguage("markdown", markdown);
lowlight.registerLanguage("objectivec", objectivec);
lowlight.registerLanguage("perl", perl);
lowlight.registerLanguage("php", php);
lowlight.registerLanguage("php-template", phpTemplate);
lowlight.registerLanguage("plaintext", plaintext);
lowlight.registerLanguage("python", python);
lowlight.registerLanguage("python-repl", pythonRepl);
lowlight.registerLanguage("r", r);
lowlight.registerLanguage("ruby", ruby);
lowlight.registerLanguage("rust", rust);
lowlight.registerLanguage("scss", scss);
lowlight.registerLanguage("shell", shell);
lowlight.registerLanguage("sql", sql);
lowlight.registerLanguage("swift", swift);
lowlight.registerLanguage("typescript", typescript);
lowlight.registerLanguage("vbnet", vbnet);
lowlight.registerLanguage("wasm", wasm);
lowlight.registerLanguage("xml", xml);
lowlight.registerLanguage("yaml", yaml);
// src/tiptap/index.js
import css2 from "highlight.js/lib/languages/css";
import js from "highlight.js/lib/languages/javascript";
import ts from "highlight.js/lib/languages/typescript";
import html from "highlight.js/lib/languages/xml";
// src/tiptap/BackgroundColor.js
import { Extension } from "@tiptap/core";
var BackgroundColor = Extension.create({
    name: "backgroundColor",
    addOptions: function addOptions() {
        return {
            types: [
                "textStyle"
            ]
        };
    },
    addGlobalAttributes: function addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    backgroundColor: {
                        default: null,
                        parseHTML: function(element) {
                            var _element_style_backgroundColor;
                            return (_element_style_backgroundColor = element.style.backgroundColor) === null || _element_style_backgroundColor === void 0 ? void 0 : _element_style_backgroundColor.replace(/['"]+/g, "");
                        },
                        renderHTML: function(attributes) {
                            if (!attributes.backgroundColor) {
                                return {};
                            }
                            return {
                                style: "background-color: ".concat(attributes.backgroundColor)
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands: function addCommands() {
        return {
            setBackgroundColor: function(color) {
                return function(param) {
                    var chain = param.chain;
                    return chain().setMark("textStyle", {
                        backgroundColor: color
                    }).run();
                };
            },
            unsetBackgroundColor: function() {
                return function(param) {
                    var chain = param.chain;
                    return chain().setMark("textStyle", {
                        backgroundColor: null
                    }).removeEmptyTextStyle().run();
                };
            }
        };
    }
});
var BackgroundColor_default = BackgroundColor;
// src/tiptap/Color.js
import { Extension as Extension2 } from "@tiptap/core";
var Color = Extension2.create({
    name: "color",
    addOptions: function addOptions() {
        return {
            types: [
                "textStyle"
            ]
        };
    },
    addGlobalAttributes: function addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    color: {
                        default: null,
                        parseHTML: function(element) {
                            var _element_style_color;
                            return (_element_style_color = element.style.color) === null || _element_style_color === void 0 ? void 0 : _element_style_color.replace(/['"]+/g, "");
                        },
                        renderHTML: function(attributes) {
                            if (!attributes.color) {
                                return {};
                            }
                            return {
                                style: "color: ".concat(attributes.color)
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands: function addCommands() {
        return {
            setColor: function(color) {
                return function(param) {
                    var chain = param.chain;
                    return chain().setMark("textStyle", {
                        color: color
                    }).run();
                };
            },
            unsetColor: function() {
                return function(param) {
                    var chain = param.chain;
                    return chain().setMark("textStyle", {
                        color: null
                    }).removeEmptyTextStyle().run();
                };
            }
        };
    }
});
var Color_default = Color;
// src/tiptap/index.js
lowlight.registerLanguage("html", html);
lowlight.registerLanguage("css", css2);
lowlight.registerLanguage("js", js);
lowlight.registerLanguage("ts", ts);
var inlineExtensions = [
    Document,
    Text,
    TextStyle,
    Typography,
    Bold,
    Italic,
    Underline,
    Strike,
    Code,
    Highlight,
    Subscript,
    Superscript,
    Link,
    BackgroundColor_default,
    Color_default,
    Paragraph
];
var minimalExtensions = [
    ListItem,
    HardBreak,
    Heading,
    Blockquote,
    CodeBlockLowlight.configure({
        lowlight: lowlight
    }),
    HorizontalRule,
    BulletList,
    OrderedList,
    TextAlign.configure({
        alignments: [
            "left",
            "center",
            "right",
            "justify"
        ],
        types: [
            "heading",
            "paragraph"
        ]
    }),
    Image.configure({
        allowBase64: true
    })
];
var tiptap_default = {
    extractMentions: extractMentions,
    extractMentionsWithText: extractMentionsWithText,
    /**
   * Extract plaintext summary
   *
   * @param content TipTap JSON
   * @returns {String} Plaintext extracted from the content, or the empty string
   */ extractPlaintext: function extractPlaintext(content) {
        if (typeof content === "string") {
            return content;
        }
        var text = extractFragments(content).join(" ");
        return removeDoubleSpaces(text);
    },
    generateHTML: function generateHTML1(content) {
        var isInline = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return generateHTML(content, _to_consumable_array(inlineExtensions).concat(_to_consumable_array(isInline ? [] : minimalExtensions)));
    },
    generateJSON: function generateJSON1(content) {
        var isInline = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return generateJSON(content, _to_consumable_array(inlineExtensions).concat(_to_consumable_array(isInline ? [] : _to_consumable_array(minimalExtensions).concat([
            Table,
            TableRow,
            TableHeader,
            TableCell
        ]))));
    },
    inlineExtensions: inlineExtensions,
    isNotBlank: isNotBlank,
    minimalExtensions: minimalExtensions
};
function isNotBlank(obj) {
    if (!obj) {
        return false;
    }
    if ([
        "text",
        "mention",
        "variable",
        "images",
        "iframe"
    ].includes(obj.type)) {
        return true;
    }
    if (obj.content) {
        return obj.content.some(isNotBlank);
    }
    return false;
}
function extractMentions(obj) {
    if (!obj || !obj.content) {
        return [];
    }
    var slugs = obj.content.map(function(c2) {
        if (c2.type === "mention") {
            return c2.attrs.id;
        }
        return extractMentions(c2);
    }).flat();
    return Array.from(new Set(slugs.filter(function(x) {
        return x;
    })));
}
function extractTextAroundSlug(text, slug) {
    var index = text.indexOf(slug);
    var start = index - 75;
    var end = index + slug.length + 75;
    return text.substring(start, end);
}
function extractMentionsWithText(obj, src) {
    if (!obj || !obj.content) {
        return {};
    }
    var mentions = {};
    obj.content.forEach(function(c2) {
        if (c2.type === "mention") {
            var plainText = extractFragments(src, c2.attrs.id).join("");
            var textWithSlug = extractTextAroundSlug(plainText, c2.attrs.id);
            var regex = new RegExp(c2.attrs.id, "g");
            mentions[c2.attrs.id] = [];
            mentions[c2.attrs.id].push(textWithSlug.replace(regex, c2.attrs.label));
        }
        if (c2.content) {
            mentions = Object.assign(extractMentionsWithText(c2, src ? src : obj), mentions);
        }
    });
    return mentions;
}
function extractFragments(content, slug) {
    if (!content) {
        return [];
    }
    var fragments = [];
    if (content.type === "text" && content.text) {
        fragments.push(content.text);
    }
    if (content.type === "mention" && content.attrs) {
        if (slug && content.attrs.id === slug) {
            fragments.push(content.attrs.id);
        } else {
            fragments.push(content.attrs.label);
        }
    }
    if (content.content) {
        var _fragments;
        content.content.forEach(function(node) {
            return (_fragments = fragments).push.apply(_fragments, _to_consumable_array(extractFragments(node, slug)));
        });
    }
    return fragments;
}
function removeDoubleSpaces(text) {
    return text.replace(/\s+/g, " ");
}
// src/urls.js
var urls_default = Object.entries(paths_default).reduce(function(urls, param) {
    var _param = _sliced_to_array(param, 2), key = _param[0], fn = _param[1];
    var _fn;
    urls[key] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return "".concat(args[0]).concat((_fn = fn).call.apply(_fn, [
            paths_default
        ].concat(_to_consumable_array(args.slice(1)))));
    };
    return urls;
}, {});
function isValidURL(url) {
    try {
        return typeof url === "string" && !!new URL(url);
    } catch (error2) {
        return false;
    }
}
export { assistant_fallback_reasons_default as assistant_fallback_reasons, capabilities_exports as capabilities, constants_default as constants, exports_default as exports, integrations_exports as integrations, isValidURL, measurements_exports as measurements, names_default as names, paths_default as paths, payload_limits_default as payloadLimits, permissions_default as permissions, personal_email_domains_default as personalEmailDomains, posts_exports as posts, schemata_default as schemata, tiptap_default as tiptap, urls_default as urls };
